"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const firestore_1 = require("@react-query-firebase/firestore");
const firestore_2 = require("firebase/firestore");
const keyFactory_1 = require("../keyFactory");
/** Te trae un conjunto de eventos dado tu uid y país
 * puede ser autonomous, prescription o analysis
*/
function useCollectionEvent(firestore, type, uid, country, firestoreHookOption, queryOption) {
    const eventPath = {
        "analysis": "events/requests/analysis",
        "autonomous": "events/labs/autonomous",
        "prescriptions": `events/prescriptions/${country}`
    };
    const eventRef = (0, firestore_2.collection)(firestore, eventPath[type]);
    const QueryRef = (0, firestore_2.query)(eventRef, (0, firestore_2.where)("uid", "==", uid));
    return (0, firestore_1.useFirestoreQueryData)(keyFactory_1.FirestoreKeys.Events({
        name: "Events",
        path: eventPath[type]
    }, [type, uid]), QueryRef, firestoreHookOption, queryOption);
}
exports.default = useCollectionEvent;
